/**
*  Get Block Column.
*
* @param {String} colClassName ClassName
* @returns {Array} Block column.
*/
const ALLOWED_BLOCKS = [ 'core/paragraph', 'core/heading', 'core/list',  'core/quote', 'core/table']
const getBlockColumn = ( colClassName, colWidth ) => {
return [
	'core/column',	{ 
		className: colClassName,
		width: colWidth,

	},
	[
		[
			'core/group',
			{
				className: 'page__content-column-content',
				allowedBlocks: ALLOWED_BLOCKS,
			},
		],
	]
];
};

export const blockColumns = [
[
	'core/columns',
	{
		className: 'page__content -columns -column-4 text',
		align: 'full'
		
	},
	[
		getBlockColumn( 'page__content-column-4-1'),
		getBlockColumn( 'page__content-column-4-2'),
		getBlockColumn( 'page__content-column-4-3'),
		getBlockColumn( 'page__content-column-4-4')
	] 
],
];